import React from 'react';
import data from './notice.json';
import cx from './index.module.scss';

const TherapyNotice = () => {
  return (
    <div className={cx('therapy-notice')}>
      <div className={cx('title')}>{data?.title}</div>

      <div className={cx('header')}>
        <div>{data?.header?.salutation}</div>
        <div>{data?.header?.intro}</div>
      </div>

      {data?.sections?.map((section, sectionIndex) => (
        <div key={sectionIndex} className={cx('section')}>
          <div className={cx('sub-title')}>{section?.title}</div>

          {section?.items?.length && (
            <div className={cx('section-items')}>
              {section?.items.map((item, itemIndex) => (
                <div key={itemIndex} className={cx('item')}>
                  <div>{itemIndex + 1 + '.'} </div>
                  <div>{item}</div>
                </div>
              ))}
            </div>
          )}

          {section?.subsections?.length && (
            <div className={cx('subsection-items')}>
              {section?.subsections?.map((subsection, subIndex) => (
                <div key={subIndex} className={cx('section-items')}>
                  <div className={cx('sub-section-title')}>{subsection?.title}</div>
                  {subsection?.items.map((item, itemIndex) => (
                    <div key={itemIndex} className={cx('item')}>
                      <div>{itemIndex + 1 + '. '}</div>
                      <div>{item}</div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      <div className={cx('special-statement')}>
        <div className={cx('sub-title')}>{data?.specialStatement?.title}</div>
        <div>{data?.specialStatement?.content}</div>
      </div>

      <div className={cx('special-statement')}>
        <div>{data?.closing?.notice}</div>
        <div className={cx('company')}>{data?.closing?.company}</div>
      </div>
      <div className={cx('page-bottom')} />
    </div>
  );
};

export default TherapyNotice;
